import { render, staticRenderFns } from "./TemplatePage.vue?vue&type=template&id=5296f767&scoped=true&xmlns%3Av=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./TemplatePage.vue?vue&type=script&lang=js&"
export * from "./TemplatePage.vue?vue&type=script&lang=js&"
import style0 from "../Style/template-page.scss?vue&type=style&index=0&id=5296f767&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5296f767",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\marketingdatabase-git\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5296f767')) {
      api.createRecord('5296f767', component.options)
    } else {
      api.reload('5296f767', component.options)
    }
    module.hot.accept("./TemplatePage.vue?vue&type=template&id=5296f767&scoped=true&xmlns%3Av=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&", function () {
      api.rerender('5296f767', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/TemplateManager/Components/TemplatePage.vue"
export default component.exports